import React from 'react';
import { Container, SubWrap, ColDiv } from 'styles';
import { NoticeList, Pagination, SubTitle, Button } from 'components';
import { useNavigate } from 'react-router-dom';

function QnaView({ list, qnaList, goDetail, paginationRequest, paginationResult, setPaginationRequest }) {
  const navigate = useNavigate();

  return (
    <Container $gap={48}>
      <SubWrap $type="first">
        <SubTitle title={list.subject} desc={list.subjectDesc} />
        <ColDiv $gap={24} $alignItems="flex-end" $mAlignItems="center">
          <Button label="글쓰기" btnType="write" btnStyle="fill" $mDisplay="none" onClick={() => navigate('/community/qna/write')} />
          <NoticeList list={qnaList} onClick={goDetail} type="qna" hideDownloadFile />
          <Button label="글쓰기" btnType="write" btnStyle="fill" onClick={() => navigate('/community/qna/write')} />
        </ColDiv>
      </SubWrap>
      <Pagination paginationRequest={paginationRequest} paginationResult={paginationResult}
          setPaginationRequest={setPaginationRequest} />
    </Container>
  );
}

export default QnaView;
